<template>
    <!-- 对话框 -->
    <el-drawer title="下载二维码" :visible.sync="show" :with-header="false" :before-close="closeDialog" size="1000px">
        <div class="container">
            <template>
                <div class="tableScroll">
                    <el-table :data="tableData" class="table" ref="multipleTable" header-cell-class-name="table-header">
                        <el-table-column prop="" label="批次" min-width="120">
                            <template slot-scope="scope"> 第{{ scope.row.batch_no }}批次 </template></el-table-column
                        >
                        <el-table-column prop="qrcode_url" label="二维码" min-width="120">
                            <template slot-scope="scope">
                                <el-image
                                    style="width: 80px; height: 80px; border: 1px solid #eee; border-radius: 5px"
                                    :src="scope.row.qrcode_url"
                                    v-if="scope.row.qrcode_url != ''"
                                    :preview-src-list="srcList"
                                >
                                </el-image>
                            </template>
                        </el-table-column>

                        <el-table-column label="状态" prop="is_use.alias" min-width="130"> </el-table-column>
                        <el-table-column label="使用日期" prop="use.YmdHis" min-width="130"></el-table-column>
                        
                        <el-table-column label="单号" prop="order_code" min-width="130"
                            ><template slot-scope="scope">
                                {{ scope.row.order_code == '' ? '--' : scope.row.order_code }}
                            </template></el-table-column
                        >
                    </el-table>

                    <div class="pagination">
                        <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="search_data.page"
                            :page-sizes="[10, 20, 30, 40, 50]"
                            :page-size="search_data.limit"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="result_data.count"
                        >
                        </el-pagination>
                    </div>
                </div>
            </template>
            <!-- 对话框底部按钮 -->
            <div style="display: flex; justify-content: center">
                <el-button @click="closeDialog">关闭</el-button>
            </div>
        </div>
    </el-drawer>
</template>

<script>
var _this;

export default {
    props: {
        isShow: Boolean,
        data: ''
    },
    watch: {
        isShow(newData, oldData) {
            _this.show = true;
            _this.search_data.batch_no = _this.data;

            _this.searchCooperateWineLists();
        }
    },
    data() {
        return {
            show: false,
            tableData: [],
            srcList: [],
            search_data: {
                page: 1,
                limit: 10,
                batch_no: ''
            },
            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
       
    },
    methods: {
        searchCooperateWineLists() {
            _this.search_data.page = 1;
            _this.cooperateWineLists();
        },
        cooperateWineLists() {
            _this
                .$post('/Cooperatewine/cooperateWineLists', _this.search_data, _this.search_rules)
                .then((res) => {
                    _this.tableData = res.data;
                    _this.result_data = res;
                    _this.srcList.length = 0;
                    for (let i = 0; i < res.data.length; i++) {
                        _this.srcList.push(res.data[i].qrcode_url);
                    }
                })
                .catch((err) => {});
        },
        //下拉条（每页显示多少数据）变化
        handleSizeChange(val) {
            _this.search_data.limit = val;

            //初始化列表
            _this.cooperateWineLists();
        },
        //页码变化
        handleCurrentChange(val) {
            _this.search_data.page = val;

            //初始化列表
            _this.cooperateWineLists();
        },
        //翻页组件的回调
        pages_function() {
            //初始化列表
            _this.cooperateWineLists();
        },
        batchChange(val) {
            _this.search_data.batch_no = val;

            console.log(val);
        },

        // 关闭方法
        closeDialog() {
            _this.show = false;
            _this.search_data = {
                page: 1,
                limit: 10,
                batch_no: ''
            };
        }
    }
};
</script>

<style scoped>
.form-box {
    padding: 20px;
    box-sizing: border-box;
    margin-right: 0;
    width: 100%;
}

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409eff;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
}

.avatar {
    width: 178px;
    height: 178px;
    display: block;
}

.el-form-second {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-around;
}

.avatar-uploader {
    width: 100px;
    height: 100px;
}

.tableScroll {
    max-height: 600px;
    overflow: hidden;
    overflow-y: auto;
}
</style>